import { useAuthServiceApiV2 } from '~/composables/useAuthServiceApi';

export default function ContactsVerification() {
  return {
    get: async (contact) =>
      useAuthServiceApiV2('/contacts_verification', {
        method: 'GET',
        params: { contact },
      }),
  };
}
